export default __webpack_public_path__ + "static/media/mentor.42eebead.png";